import { render, staticRenderFns } from "./OrderDocumentInfoModalPublic.vue?vue&type=template&id=0b86e27e"
import script from "./OrderDocumentInfoModalPublic.vue?vue&type=script&lang=js"
export * from "./OrderDocumentInfoModalPublic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports